'use client';

/**
 * 购买保留当前页面与草稿；仅显式 billing 路由使用独立购买页面。
 */

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import dynamic from 'next/dynamic';
import { usePricingModalStore } from '@/lib/stores/pricing-modal-store';

const ProjectPricingModal = dynamic(
  () => import('./PricingModal').then((module) => module.PricingModal),
  { ssr: false },
);

export function PurchaseRouteRedirector() {
  const pathname = usePathname();
  const isOpen = usePricingModalStore(s => s.isOpen);
  const openPricingModal = usePricingModalStore(s => s.openPricingModal);

  useEffect(() => {
    const openFromHash = () => {
      const params = new URLSearchParams(window.location.search);
      if (window.location.hash !== '#pricing' && params.get('pricing') !== '1') return;
      openPricingModal({ triggerReason: 'upgrade', defaultTab: 'upgrade' });
    };

    openFromHash();
    window.addEventListener('hashchange', openFromHash);

    return () => {
      window.removeEventListener('hashchange', openFromHash);
    };
  }, [openPricingModal]);

  // Keep the source mounted on every surface, including templates and Explore.
  // The standalone billing route owns its own modal.
  return pathname !== '/billing/upgrade' && isOpen ? <ProjectPricingModal /> : null;
}
